import { render, staticRenderFns } from "./RequisitionSettings.vue?vue&type=template&id=43e94787"
import script from "./RequisitionSettings.vue?vue&type=script&lang=js"
export * from "./RequisitionSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports